import IconButton from 'apollo-react/components/IconButton';
import Trash from 'apollo-react-icons/Trash';
import React, { useState } from 'react';

import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal';

const DeleteActionCell = ({ row: { rowId, actorsTableKey, deleteRow } }) => {
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleDelete = () => {
    deleteRow({ rowId, actorsTableKey });
  };

  return (
    <>
      <IconButton size="medium" onClick={() => setDeleteModalOpen(true)}>
        <Trash />
      </IconButton>
      <DeleteConfirmationModal
        open={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onDeleteConfirm={handleDelete}
      />
    </>
  );
};

export default DeleteActionCell;
